export default __webpack_public_path__ + "static/media/mars.27b5ec30.svg";